import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getContentData } from './utils/content';
import Actions from './components/Actions';
import BackButton from './components/BackButton';
import Steps from './components/Steps';
import { H1 } from './components/typography';

const PageTitle = styled(H1)`
  color: ${props => props.theme.color.textDark} !important;
  font-size: 26px;
  line-height: 38px;
  margin-bottom: 10px;
  text-align: center;
  @media (max-width: 599px) {
    font-size: 18px;
  }
`;

const SubTitle = styled.div`
  text-align: center;
  font-size: 14px;
  padding: 0 15%;
`;

class Content extends React.Component {
  static propTypes = {
    data: PropTypes.object
  };

  state = {
    data: this.props.data,
    isMobile: false
  };

  componentDidMount() {
    if (
      process.env.NODE_ENV !== 'production' &&
      !this.props.data &&
      typeof window !== 'undefined'
    ) {
      getContentData().then(data => {
        this.setState({ data });
      });
    }
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      // figure out model in either desktop or mobile view for Whirlpool
      const urlParams = window.location.href.split('/');
      const model = urlParams.reduce((acc, item, i) => {
        return item === 'support' ? urlParams[i + 1] : acc;
      }, '');

      this.setState({ isMobile: width < 900, model });
    }
    const stoargeExists = window.sessionStorage.getItem('breadCrumbs');
    // set a new stoarge is the page is hit from an external link
    if (!stoargeExists) {
      window.sessionStorage.setItem(
        'breadCrumbs',
        JSON.stringify({
          back: false,
          crumbs: [window.location.href]
        })
      );
    }
    const sessionCrumbs = JSON.parse(
      window.sessionStorage.getItem('breadCrumbs')
    ).crumbs;
    const sessionBack = JSON.parse(window.sessionStorage.getItem('breadCrumbs'))
      .back;
    // get crumb from session storage
    const crumb = sessionBack
      ? sessionCrumbs[sessionCrumbs.length - 2]
      : sessionCrumbs[sessionCrumbs.length - 1];

    if (window.location.href !== crumb || sessionBack) {
      // this condition prevents page reload to mess with session storage
      // or when the back button has been clicked
      window.sessionStorage.setItem(
        'breadCrumbs',
        JSON.stringify({
          back: false,
          crumbs: sessionBack
            ? sessionCrumbs
            : [...sessionCrumbs, window.location.href]
        })
      );
    }
    this.setState({ breadCrumb: crumb });
  }

  createMarkup() {
    return { __html: this.state.data.subTitle };
  }

  updateSessionCrumbs() {
    const newCrumbs = JSON.parse(window.sessionStorage.getItem('breadCrumbs'))
      .crumbs;
    if (newCrumbs.length > 1 || !newCrumbs[0].indexOf('help') !== -1) {
      // this check is to prevent the page from breaking when landed on
      // from an external link (ie bookmark)
      newCrumbs.pop();
    }

    window.sessionStorage.setItem(
      'breadCrumbs',
      JSON.stringify({
        back: true,
        crumbs: newCrumbs
      })
    );

    return true;
  }

  render() {
    return this.state.data ? (
      <div>
        <div>
          <BackButton
            breadCrumb={this.state.breadCrumb}
            updateSessionCrumbs={this.updateSessionCrumbs}
          />
          <PageTitle>{this.state.data.title}</PageTitle>
          <SubTitle dangerouslySetInnerHTML={this.createMarkup()} />
        </div>
        <hr />
        {this.state.data.guide.steps.map((step, i) => {
          return <Steps key={i} number={i + 1} step={step} />;
        })}
        <Actions
          actions={this.state.data.actions}
          isMobile={this.state.isMobile}
          model={this.state.model}
        />
      </div>
    ) : null;
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/Content.js